"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialDatePicker = exports.MaterialDatePickerUnstyled = void 0;
const icons_1 = require("client/components/icons");
const material_ui_pickers_1 = require("material-ui-pickers");
const moment = require("moment");
const react_1 = require("react");
const React = require("react");
require("./date-picker.less");
const MIN_DATE = "1000-01-01";
const MAX_DATE = moment()
    .add(500, "years")
    .format("YYYY-MM-DD");
class MaterialDatePickerUnstyled extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleOnChange = (value) => {
            this.props.onChange && this.props.onChange(value);
        };
    }
    render() {
        const { className = "", disabled = false, disableFuture = false, disablePast = false, format = "MM/DD/YYYY", label, mask = [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/], placeholder = "MM/DD/YYYY", required, value, missing } = this.props;
        const isMissing = missing ? "datepicker--missing" : "";
        return (React.createElement("div", { className: `datepicker ${className} ${isMissing}` },
            React.createElement(material_ui_pickers_1.DatePicker, { animateYearScrolling: false, dialogContentClassName: "datepicker__modal", format: format, keyboard: true, label: label, leftArrowIcon: React.createElement(icons_1.Chevron, { direction: "left" }), mask: mask, maxDate: MAX_DATE, minDate: MIN_DATE, onChange: this.handleOnChange, placeholder: placeholder, required: required, rightArrowIcon: React.createElement(icons_1.Chevron, { direction: "right" }), value: value, keyboardIcon: React.createElement(icons_1.CalendarIcon, null), disabled: disabled, disablePast: disablePast, disableFuture: disableFuture })));
    }
}
exports.MaterialDatePickerUnstyled = MaterialDatePickerUnstyled;
exports.MaterialDatePicker = MaterialDatePickerUnstyled;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/date-picker/date-picker.tsx
// module id = 95
// module chunks = 0